import script from "./Repeater.vue?vue&type=script&setup=true&lang=js"
export * from "./Repeater.vue?vue&type=script&setup=true&lang=js"

import "./Repeater.vue?vue&type=style&index=0&id=8d261b42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d261b42"]])

export default __exports__